import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DataTable } from "~/Components";
import { magpCMSApi } from "~/Services";
import { renderActionsColumn, renderDateColumn, renderPublishedColumn } from "~/Utils/TableRenderFunction";
import { useContractAdministrationProcessFlowChart } from "../Manual.hook";
import { ProcurementPlanningProcessFlowChartProps } from "../ProcurementPlanning/ProcurementPlanningProcessFlowChart";
export const ContractAdministrationProcessFlowChart: React.FC<ProcurementPlanningProcessFlowChartProps> = ({
  listId,
  toggleId,
}) => {
  const query = useQuery();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const firstQueryTab = query.get("activeTab");
  const secondQueryTab = query.get("subActiveTab");
  const thirdQueryTab = query.get("thirdChildActiveTab");

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  const id = searchParams.get("id");

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchData,
  } = useContractAdministrationProcessFlowChart(selectedRowData?.id ?? null);

  useEffect(() => {
    if (selectedRowData?.id) {
      refetchData();
    }
  }, [selectedRowData?.id]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const url = `/api/get-contract-process-flow-chart/all-fields?listId=${listId}&toggleId=${toggleId}`;
      try {
        const res = await magpCMSApi.get(url);
        if (res && res.data) {
          setData(res.data);
        }
      } catch (err) {
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  // if (id && selectedRowData) {
  //   return <EditProcurementPlanningProcessFlowChart record={selectedRowData} />;
  // }

  const columns: TableColumnsType = [
    {
      title: "Id",
      dataIndex: "seqNumber",
      key: "seqNumber",
      width: 60,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: renderDateColumn,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 100,
      render: renderDateColumn,
    },
    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      width: 60,
      render: (value: string) => renderPublishedColumn(value),
    },
    {
      title: "Actions",
      key: "actions",
      width: 60,
      render: (record: any) =>
        renderActionsColumn(record, setSelectedRowData, setDrawerVisible, (e: any) => {
          e.preventDefault();
          navigate(
            `/dedicated/magp/manual/contractAdministration?activeTab=${firstQueryTab}&subActiveTab=${secondQueryTab}&thirdChildActiveTab=${thirdQueryTab}&fourthChildActiveTab=${firstQueryTab + `ProcessFlowChart`}&editId=${record.id}`,
            { state: { record } }
          );
        }),
    },
  ];

  return (
    <>
      <DataTable
        tabOffset={60}
        columns={columns}
        className="table-clickable"
        tableData={data}
        height={1000}
        isLoading={isLoading}
        exportFileName="CONTRACT"
        isPagination={false}
        multiSelect={false}
        hideExport={true}
        isServerSearchApi={false}
        searchPlaceholderText={"Search"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
      />
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "contractAdministrationProcessFlowChart") as ModuleConfig]}
        data={drilldown?.[0]}
      />
    </>
  );
};
